import React from 'react';
import { GlobeIcon, LockIcon } from 'lucide-react';

/** Réassurance affichée juste sous le bouton du checkout. */
export function SecurePaymentNote({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`mx-auto flex w-full max-w-[420px] flex-col gap-2.5 rounded-[14px] border border-brand-cta/25 bg-brand-cta/[0.06] px-5 py-4 text-left ${className}`} data-id="element-208" data-mp="1c8zbvc6dqgq6">
      <p className="flex items-center gap-2.5 font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-209" data-mp="1m7ooapfib8z1">
        <LockIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2} aria-hidden="true" data-id="element-210" data-mp="1q8i7j5i07zll" />
        Paiement 100 % sécurisé et crypté
      </p>
      <p className="flex items-center gap-2.5 font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-211" data-mp="1v0idbekr9mq3">
        <GlobeIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2} aria-hidden="true" data-id="element-212" data-mp="200xqa514ks7j" />
        Paiement traité dans votre devise locale
      </p>
    </div>;
}